// extracted by mini-css-extract-plugin
export default {"root":"TgiatVyB","errorCode":"OBntAuSC","errorMessage":"xDauQv4z","errorBackground":"RaJjlRXk","errorGround":"s6iV2UKj"};